<template>
  <v-container class="px-0 py-0">
    <v-form ref="analiticoFilterForm">
      <template v-if="[1, 46, 192].includes(grupoEconomico)">
      <v-row class="mt--12 pt--12"> 
            <v-label class="pt-2 px-3" >Nível de item</v-label>
          <v-switch
            v-model="formData.relatorio_sintetico"
            label="Nível de guia"
            color="primary"
            class="mr-0 mt-0"
            small
            ></v-switch>
          </v-row>
        </template>
      <v-row class="pa-0">
        <v-col cols="12" sm="6" md="3" class="px-3 py-0">
          <label>Prestador</label>
          <v-autocomplete
            v-model="formData.prestador_id"
            :items="prestadoresFilter"
            item-value="id"
            item-text="prest_nome"
            label="Selecione"
            multiple
            chips
            outlined
            flat
            solo
            dense
            small-chips
            :disabled="prestadoresFilter.length == 1"

            :search-input.sync="searchInput"
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleAllPrestadores">
                <v-list-item-content>
                  <v-list-item-title>{{
                    isAllPrestadoresSelected ? "NENHUM" : "TODOS"
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template v-slot:selection="data">
              <span v-if="isAllPrestadoresSelected && data.index == 0">TODOS</span>
              <v-chip
                v-if="!isAllPrestadoresSelected && data.index < 2"
                small
                label
                class="ma-1"
                :style="
                  formData.prestador_id.length > 1
                    ? 'max-width:30%'
                    : 'max-width:100%'
                "
                >{{ data.item.prest_nome }}</v-chip
              >
              <span v-if="!isAllPrestadoresSelected && data.index == 2" class="ml-2 grey--text caption">
                (+{{
                  formData.prestador_id.length == 3
                    ? formData.prestador_id.length - 2 + " outro"
                    : formData.prestador_id.length - 2 + " outros"
                }})
              </span>
            </template>
            <template v-slot:item="data">
                  <v-list-item
                    @click="toggleAutocomplete(data.item, 'prestador_id')"
                    :class="
                      formData.prestador_id.includes(data.item.id)
                        ? 'primary--text v-list-item--active'
                        : ''
                    "
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{
                        data.item.prest_nome
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="px-3 py-0">
          <label>Operadoras</label>
          <v-autocomplete
            v-model="formData.operadora_ans_id"
            :items="operadorasFilter"
            item-value="id"
            item-text="oper_nome"
            label="Selecione"
            multiple
            chips
            outlined
            flat
            solo
            dense
            filled
            :search-input.sync="searchInput"
          >
          <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleAllOperadoras">
                <v-list-item-content>
                  <v-list-item-title>{{
                    isAllOperadorasSelected ? "NENHUM" : "TODOS"
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
            <template v-slot:selection="data">
              <span v-if="isAllOperadorasSelected && data.index == 0">TODOS</span>
              <v-chip
                 v-if="!isAllOperadorasSelected && data.index < 2"
                small
                label
                class="ma-1"
                :style="
                  formData.operadora_ans_id.length > 1
                    ? 'max-width:30%'
                    : 'max-width:100%'
                "
                >{{ data.item.oper_nome }}</v-chip
              >
              <span v-if="!isAllOperadorasSelected && data.index == 2" class="ml-2 grey--text caption">
                (+{{
                  formData.operadora_ans_id.length == 3
                    ? formData.operadora_ans_id.length - 2 + " outro"
                    : formData.operadora_ans_id.length - 2 + " outros"
                }})
              </span>
            </template>
            <template v-slot:item="data">
                  <v-list-item
                    @click="toggleAutocomplete(data.item, 'operadora_ans_id')"
                    :class="
                      formData.operadora_ans_id.includes(data.item.id)
                        ? 'primary--text v-list-item--active'
                        : ''
                    "
                  >
                    <v-list-item-content>
                      <v-list-item-title>{{
                        data.item.oper_nome
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col class="px-3 pr-sm-2 py-0" cols="12" sm="6" md="2">
          <label>Tipo de Registro</label>
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            v-model="formData.tipo_registro"
            :items="tipo_registro_lista"
            placeholder="Selecione"
            outlined
            item-text="descricao"
            item-value="id"
          ></v-select>
        </v-col>
        <v-col sm="6" xm="12" md="3" class="px-3 pr-sm-2 py-0">
          <v-switch
            v-model="formData.glosados"
            label="Apenas itens glosados"
            color="primary"
            class="mr-0 mt-5"
            ></v-switch>
          </v-col>
      </v-row>
      <v-row class="px-0 py-0">
        <v-col cols="12" sm="6" md="2">
          <span>Data 1ª publicação</span><br>
          <label>De</label>
          <v-menu
            ref="dtPublicacaoI"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="datePublicacaoIFormatted"
                dense
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="formData.data_1a_publicacao_inicio = parseDate(datePublicacaoIFormatted)"
                :rules="(formData.data_inicio == null && formData.data_recurso_inicio == null && formData.data_fim == null && formData.data_recurso_fim == null)?[formRules.requiredField, formRules.typeDateFormated]:[formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker
              color="primary"
              :min="dataMinima"
              :max="formData.data_1a_publicacao_fim"
              v-model="formData.data_1a_publicacao_inicio"
              @input="datePublicacaoIFormatted = formatDate(formData.data_1a_publicacao_inicio)"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span></span><br>
          <label>até</label>
          <v-menu
            ref="dtPublicacaoF"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="datePublicacaoFFormatted"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                dense
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="formData.data_1a_publicacao_fim = parseDate(datePublicacaoFFormatted)"
                :rules="(formData.data_inicio == null && formData.data_recurso_inicio == null && formData.data_fim == null && formData.data_recurso_fim == null)?[formRules.requiredField, formRules.typeDateFormated]:[formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker
              color="primary"
              :min="formData.data_1a_publicacao_inicio"
              v-model="formData.data_1a_publicacao_fim"
              @input="datePublicacaoFFormatted = formatDate(formData.data_1a_publicacao_fim)"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span>Data do recurso</span><br>
          <label>De</label>
          <v-menu
            ref="dtRecursoI"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateRecursoIFormatted"
                dense
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="formData.data_recurso_inicio = parseDate(dateRecursoIFormatted)"
                :rules="(formData.data_inicio == null && formData.data_1a_publicacao_inicio == null && formData.data_fim == null && formData.data_1a_publicacao_fim == null)?[formRules.requiredField, formRules.typeDateFormated]:[formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker
              color="primary"
              :min="dataMinima"
              :max="formData.data_recurso_fim"
              v-model="formData.data_recurso_inicio"
              @input="dateRecursoIFormatted = formatDate(formData.data_recurso_inicio)"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span></span><br>
          <label>até</label>
          <v-menu
            ref="dtRecursoF"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateRecursoFFormatted"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                dense
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="formData.data_recurso_fim = parseDate(dateRecursoFFormatted)"
                :rules="(formData.data_inicio == null && formData.data_1a_publicacao_inicio == null && formData.data_fim == null && formData.data_1a_publicacao_fim == null)?[formRules.requiredField, formRules.typeDateFormated]:[formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker
              color="primary"
              :min="formData.data_recurso_inicio"
              v-model="formData.data_recurso_fim"
              @input="dateRecursoFFormatted = formatDate(formData.data_recurso_fim)"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span>Data do pagamento</span><br>
          <label>De</label>
          <v-menu
            ref="dtI"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateIFormatted"
                dense
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="formData.data_inicio = parseDate(dateIFormatted)"
                :rules="(formData.data_1a_publicacao_inicio == null && formData.data_recurso_inicio == null && formData.data_1a_publicacao_fim == null && formData.data_recurso_fim == null)?[formRules.requiredField, formRules.typeDateFormated]:[formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker
              color="primary"
              :min="dataMinima"
              :max="formData.data_fim"
              v-model="formData.data_inicio"
              @input="dateIFormatted = formatDate(formData.data_inicio)"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <span></span><br>
          <label>até</label>
          <v-menu
            ref="dtF"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFFormatted"
                format="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                label
                dense
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="formData.data_fim = parseDate(dateFFormatted)"
                :rules="(formData.data_1a_publicacao_inicio == null && formData.data_recurso_inicio == null && formData.data_1a_publicacao_fim == null && formData.data_recurso_fim == null)?[formRules.requiredField, formRules.typeDateFormated]:[formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker
              color="primary"
              :min="formData.data_inicio"
              v-model="formData.data_fim"
              @input="dateFFormatted = formatDate(formData.data_fim)"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row class="px-0 pb-10">
        <v-spacer/>
          <v-col class="py-0 text-right">
          <v-btn
            class="mt-0"
            height="31px"
            small
            depressed
            color="primary"
            @click="sendFilter(true)"
            >Solicitar Relatório</v-btn
          >
          <v-btn
            class="mt-0 ml-4"
            height="31px"
            small
            depressed
            outlined
            color="primary"
            @click="clearFilters()"
            >Limpar Filtros</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
// import moment from "moment";
import { mask } from "vue-the-mask";
import { mapState } from "vuex";
export default {
  directives: {
    mask,
  },
  data() {
    return {
      dataMinima: '2022-01-01',
      formData: {
        data_fim: null,
        data_inicio: null,
        data_1a_publicacao_fim: null,
        data_1a_publicacao_inicio: null,
        data_recurso_fim: null,
        data_recurso_inicio: null,
        modulo_operadora: "recebiveis",
        operadora_ans_id: [],
        prestador_id: [],
        tipo_registro: null,
        glosados: false,
        relatorio_sintetico: false
      },
      dateFFormatted: null,
      dateIFormatted: null,
      datePublicacaoFFormatted: null,
      datePublicacaoIFormatted: null,
      dateRecursoFFormatted: null,
      dateRecursoIFormatted: null,
      dtI: false,
      dtF: false,
      prestadoresFilter: [],
      operadorasFilter: [],
      responsaveisFilter: [],
      searchInput: null,
      tipo_registro_lista:[
        {id: null, descricao:"Todos"},
        {id: "REGULAR", descricao:	"REGULAR"}, // TISS: 0
        {id: "RECURSO", descricao:	"RECURSO"}, // TISS: 10
        {id: "ESTORNO", descricao:	"ESTORNO"}, // TISS: 20
        {id: "DEVOLUÇÃO", descricao:	"DEVOLUÇÃO"}, // TISS: 30
        {id: "REAPRESENTAÇÃO", descricao:	"REAPRESENTAÇÃO"}, // TISS: 40
        {id: "TAXAS EXTRAS", descricao:	"TAXAS EXTRAS"}, // TISS: 50
        {id: "ITENS DE TERCEIROS", descricao:	"ITENS DE TERCEIROS"}, // TISS: 51
        {id: "COMPLEMENTO", descricao:	"COMPLEMENTO"}, // TISS: 60
        {id: "SERVIÇOS ADICIONAIS", descricao:	"SERVIÇOS ADICIONAIS"} // TISS: 61
      ]
    };
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
    }),
    isAllPrestadoresSelected() {
      if (this.formData && this.formData.prestador_id) {
        return this.prestadoresFilter.length == this.formData.prestador_id.length;
      } else {
        return false;
      }
    },
    isAllOperadorasSelected() {
      if (this.formData && this.formData.operadora_ans_id) {
        return this.operadorasFilter.length == this.formData.operadora_ans_id.length;
      } else {
        return false;
      }
    },
  },
  methods: {
    clearFilters() {
      this.dateFFormatted = null;
      this.dateIFormatted = null;
      this.formData.data_fim = null;
      this.formData.data_inicio = null;
      this.datePublicacaoFFormatted = null;
      this.datePublicacaoIFormatted = null;
      this.formData.data_1a_publicacao_fim = null;
      this.formData.data_1a_publicacao_inicio = null;
      this.dateRecursoFFormatted = null;
      this.dateRecursoIFormatted = null;
      this.formData.data_recurso_fim = null;
      this.formData.data_recurso_inicio = null;
      this.formData.operadora_ans_id = [];
      this.formData.tipo_registro = null;
      this.formData.glosados = false;
      if (this.prestadoresFilter.length > 1) {
        this.formData.prestador_id = [];
      }
      this.$refs.analiticoFilterForm.resetValidation()
    },
    changePrestador() {
      this.formData.operadora_ans_id = null;
      let {modulo_operadora, prestador_id} = this.formData
      this.getOperadoras({
        modulo_operadora,
        prestador_ids: prestador_id
      });
    },
    sendFilter() {
      if(this.formData.data_inicio == null &&
          this.formData.data_fim == null &&
          this.formData.data_recurso_inicio == null &&
          this.formData.data_recurso_fim == null &&
          this.formData.data_1a_publicacao_inicio == null &&
          this.formData.data_1a_publicacao_fim == null
      ){
              let paramModal = {
              type: "info",
              title: "Atenção:",
              message: "Selecione ao menos um período de tempo.",
              btConfirm: { name: "Ok", show: true },
              btCancel: { name: "Cancelar", show: false }
            }
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      }
      if(this.$refs.analiticoFilterForm.validate()) {
        if ( !this.formData.data_fim && this.formData.data_inicio ) {
          this.dateF = this.formData.data_inicio;
          this.formData.data_fim = this.formData.data_inicio;
        }
        this.updateFilter(this.formData);
      }
    },
    toggleAllOperadoras() {
      this.searchInput = null;
      if (!this.isAllOperadorasSelected) {
        this.formData.operadora_ans_id = this.operadorasFilter.map((el) => el.id);
      } else {
        this.formData.operadora_ans_id = [];
      }
    },
    toggleAllPrestadores() {
      this.searchInput = null;
      if (!this.isAllPrestadoresSelected) {
        this.formData.prestador_id = this.prestadoresFilter.map((el) => el.id);
      } else {
        this.formData.prestador_id = [];
      }
    },
    toggleAutocomplete(item, campo) {
      this.searchInput = null
      let index = this.formData[campo].indexOf(item.id);
      //  index > -1  está excluindo o item
      if (index > -1) {
        this.formData[campo].splice(index, 1);
      } else {
        //  index < 0  está adicionando o item
        this.formData[campo].push(item.id);
      }
      this.$nextTick();
      return;
    },
  },
  props: {
    filter: Object,
    formatDate: Function,
    grupoEconomico: Number,
    updateFilter: Function,
    getOperadoras: Function,
    operadoras: Array,
    parseDate: Function,
    prestadores: Array,
    validarForm: Boolean,
  },
  mounted() {
    this.prestadoresFilter = Array.from(this.prestadores);
    if (this.prestadoresFilter.length == 1) {
      this.formData.prestador_id = [this.prestadores[0].id];
    }
  },
  watch: {
    dateFFormatted(val) {
      if (!val) {
        this.formData.data_fim = null;
      } else {
        if (
          !!this.formData.data_inicio &&
          Date.parse(this.formData.data_inicio) >
            Date.parse(this.parseDate(val))
        ) {
          this.dateIFormatted = val;
          this.formData.data_inicio = this.parseDate(val);
        }
        this.formData.data_fim = this.parseDate(val);
      }
    },
    dateIFormatted(val) {
      if (!val) {
        this.formData.data_inicio = null;
      } else {
        if (
          !!this.formData.data_fim &&
          Date.parse(this.formData.data_fim) <
            Date.parse(this.parseDate(val))
        ) {
          this.dateFFormatted = val;
          this.formData.data_fim = this.parseDate(val);
        }
        this.formData.data_inicio = this.parseDate(val);
      }
    },
    operadoras: {
      deep: true,
      handler(val) {
        this.operadorasFilter = Array.from(val);
        if (val && val.length == 1) {
          this.formData.operadora_ans_id = val[0].id;
        }
      },
    },
    prestadores: {
      deep: true,
      handler(val) {
        this.prestadoresFilter = Array.from(val);
        if (val && val.length == 1) {
          this.formData.prestador_id = [val[0].id];
        }
      },
    },
    validarForm: {
      handler(val) {
        if (val) {
          this.sendFilter(false);
        }
      },
    },
  },
};
</script>
